import {AfterViewInit, Directive, ElementRef, NgZone} from '@angular/core';

@Directive({
    selector: '[ngxFocus]'
})
export class NgxFocus implements AfterViewInit {

    constructor(private _zone: NgZone,
                private _elementRef: ElementRef) {
    }

    ngAfterViewInit() {
        // Run the method outside the Angular zone.
        this._zone.runOutsideAngular(() => {
            this.focus();
        });
    }

    private focus() {
        // Check if set timeout exists.
        if (!setTimeout) {
            return;
        }

        // Get the native element.
        const element = this._elementRef.nativeElement;

        // Check if the element and the focus method exist, if so focus the element.
        if (!element || !element.focus) {
            return;
        }

        // Execute the focus method in a timeout.
        setTimeout(() => element.focus(), 0);
    }

}
